export default __webpack_public_path__ + "logo_one_deal.68555489.svg";